// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
  overflow: hidden;
  font-size: 16px;
  font-family: 'SourceSansPro', 'Helvetica Neue', Arial;
}

* {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["html,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  overflow: hidden;\n  font-size: 16px;\n  font-family: 'SourceSansPro', 'Helvetica Neue', Arial;\n}\n\n* {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
